import SkeletonRoot, { Props } from './Skeleton'

export default function Skeleton(props: Props) {
  return <SkeletonRoot {...props} />
}

export type { Props } from './Skeleton'
